'use client';

import { c as _c } from "react/compiler-runtime";
import { Modal, type ModalProps } from '@udemy-v2/react-dialog-components';
import { useI18n } from '@udemy-v2/i18n';
import { Button } from '@udemy-v2/react-core-components';
import { ExpressiveIcon, type ExpressiveIconName } from '@udemy-v2/icons-expressive';
import styles from './lifetime-access-modal.module.scss';
export interface LifetimeAccessModalProps {
  isOpen: ModalProps['isOpen'];
  onClose: NonNullable<ModalProps['onClose']>;
}
export const LifetimeAccessModal = t0 => {
  const $ = _c(26);
  const {
    isOpen,
    onClose
  } = t0;
  const {
    gettext
  } = useI18n();
  let t1;
  if ($[0] !== gettext) {
    t1 = gettext("Maintain access to this course even if you no longer subscribe to Personal Plan content");
    $[0] = gettext;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== t1) {
    t2 = {
      name: "new",
      text: t1
    };
    $[2] = t1;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== gettext) {
    t3 = gettext("Continue to have access to this course after you complete it \u2014 review specific content in the course or take it all over again");
    $[4] = gettext;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  if ($[6] !== t3) {
    t4 = {
      name: "learning-delivery",
      text: t3
    };
    $[6] = t3;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  let t5;
  if ($[8] !== t2 || $[9] !== t4) {
    t5 = [t2, t4];
    $[8] = t2;
    $[9] = t4;
    $[10] = t5;
  } else {
    t5 = $[10];
  }
  const items = t5;
  let t6;
  if ($[11] !== gettext) {
    t6 = gettext("What's included with Lifetime Access");
    $[11] = gettext;
    $[12] = t6;
  } else {
    t6 = $[12];
  }
  let t7;
  if ($[13] !== items) {
    t7 = <ul className={styles.list} data-purpose="lifetime-access-modal-list">{items.map(_temp)}</ul>;
    $[13] = items;
    $[14] = t7;
  } else {
    t7 = $[14];
  }
  let t8;
  if ($[15] !== gettext) {
    t8 = gettext("Close");
    $[15] = gettext;
    $[16] = t8;
  } else {
    t8 = $[16];
  }
  let t9;
  if ($[17] !== onClose || $[18] !== t8) {
    t9 = <div className={styles.footer}><Button udStyle="primary" onClick={onClose} data-purpose="lifetime-access-modal-close">{t8}</Button></div>;
    $[17] = onClose;
    $[18] = t8;
    $[19] = t9;
  } else {
    t9 = $[19];
  }
  let t10;
  if ($[20] !== isOpen || $[21] !== onClose || $[22] !== t6 || $[23] !== t7 || $[24] !== t9) {
    t10 = <Modal isOpen={isOpen} onClose={onClose} title={t6} data-purpose="lifetime-access-modal">{t7}{t9}</Modal>;
    $[20] = isOpen;
    $[21] = onClose;
    $[22] = t6;
    $[23] = t7;
    $[24] = t9;
    $[25] = t10;
  } else {
    t10 = $[25];
  }
  return t10;
};
function _temp(item) {
  return <li key={item.name} className={styles.item}><ExpressiveIcon className={styles.icon} name={item.name} colorScheme="light" size="medium" /><span className={styles.text}>{item.text}</span></li>;
}